module.exports = require('./dist/pages/_error')
